import { render, staticRenderFns } from "./messagesAndDetails.vue?vue&type=template&id=59315d1c"
import script from "./messagesAndDetails.ts?vue&type=script&lang=js&external"
export * from "./messagesAndDetails.ts?vue&type=script&lang=js&external"
import style0 from "./messagesAndDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports